import { ValuationByAllocation } from 'common/types/valuation';
import { SET_VALUATION_INFO } from './types';

export const setValuationInfo = (valuationInfo: ValuationByAllocation | null) => ({
  type: SET_VALUATION_INFO,
  valuationInfo,
});
